/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationNoteOut } from './conversationNoteOut';

export interface ConversationNotesGroup {
  conversation_id: string;
  scheduled_start: string;
  title: string;
  can_write: boolean;
  notes?: ConversationNoteOut[];
}
